import React, { useEffect, useState } from "react";
import Construction from "../../../../components/Construction";
import Empthy from "../../../../components/Empty";
import Loader from "../../../../components/Loader";
import NFTModal from "../../../../components/NFTModal";
import { UseApi } from "../../../../hooks/use-api";
import { UseDisclosure } from "../../../../hooks/use-disclosure";
import { GetRedeemListUser } from "../../../../Services/lib/admin";
import styles from "./NFT.module.sass";
import customers from "../../../../i11/Customers";
import { useUser } from "../../../../context";

const NFT = ({ item, which }) => {
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [nft, setNFT] = useState();

	const [{ data, isLoading }, fetch] = UseApi({
		service: GetRedeemListUser,
	});

	const close = () => {
		setNFT();
		onClose();
	};

	useEffect(() => {
		if (which === "redeemed") fetch(item._id);
	}, [which]);

	const open = (data_) => {
		setNFT(data_);
		onOpen();
	};

	if (which === "redeemed") {
		return (
			<>
				{isLoading ? (
					<div className={styles.loaderWrap}>
						<Loader />
					</div>
				) : data?.length === 0 ? (
					<Empthy title="No nft to show" />
				) : (
					<div className={styles.container}>
						{data?.map((e) => {
							return <Card open={open} key={e._id} item={e} />;
						})}
					</div>
				)}
				{nft && (
					<NFTModal
						visible={isOpen}
						onClose={close}
						data={nft}
						redeem
					/>
				)}
			</>
		);
	}

	if (which === "pending") {
		return <Empthy title={`Under construction. Coming soon...`} />;
	}

	return which === "minted" ? (
		<>
			{item.nfts.length === 0 ? (
				<Empthy title="No nft to show" />
			) : (
				<div className={styles.container}>
					{item.nfts.map((e) => {
						return <Card open={open} key={e._id} item={e} />;
					})}
				</div>
			)}
			<NFTModal visible={isOpen && nft} onClose={close} data={nft} />
		</>
	) : (
		<Construction />
	);
};

const Card = ({ item, open }) => {
	const { locale } = useUser();
	return (
		<div onClick={() => open(item)} className={styles.card}>
			<img src={item.image} alt="cardImage" />
			<div className={styles.nftTitle}>{item.name}</div>
			<div className={styles.price}>
				<div>{customers[locale].price}</div>
				<div>
					{item.secondaryPrice} {item.currency}
				</div>
			</div>
		</div>
	);
};

export default NFT;
